import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@src/store/store";
import {logout} from "@src/store/ducks/auth/thunks";
import cn from 'classnames'
import {NavLink} from "react-router-dom";
import logo from '@src/images/logo.svg'
import {Button} from "@src/components/Button/Button";
import {TourSvg} from "@src/components/AllSvg/ToursSvg";
import {ProfileSvg} from "@src/components/AllSvg/ProfileSvg";
import {HistorySvg} from "@src/components/AllSvg/HistorySvg";
import {NotificationSvg} from "@src/components/AllSvg/NotificationsSvg";
import {ExitSvg} from "@src/components/AllSvg/ExitSvg";
import {
    selectNotification,
    selectNotificationData,
    selectUserExchangeRates,
    selectUserInfo
} from "@src/store/ducks/user/selectors";

import {
    setSuccessPage,
    setTourChoiseOpen,
    setTourFormalisationOpen,
    triggerResetHistoryFilter
} from "@src/store/ducks/app/reducer";
import {setIsPreorder, setPassengersQuantity, setStepsState} from "@src/store/ducks/orders/reducer";

import style from '@src/components/Header/Header.module.scss'
import {setNotification} from "@src/store/ducks/user/reducer";
import {loadNotificationFunc} from "@src/store/ducks/user/thunks";

export const Header = () => {
    const dispatch = useDispatch<AppDispatch>()
    const user = useSelector(selectUserInfo)
    const notification = useSelector(selectNotification)
    const notificationData = useSelector(selectNotificationData)
    const notificationCount = notificationData.notificationsNewCount
    const exchangeRates = useSelector(selectUserExchangeRates)

    function disableScroll() {
        // Сохраняем ширину скроллбара
        document.body.style.paddingRight = `0.4rem`
    }

    // const currencies = exchangeRates
    //     ? [
    //         { code: 'USD', rate: Number(exchangeRates.usd?.rate) },
    //         { code: 'RUB', rate: Number(exchangeRates.rub?.rate) },
    //         { code: 'EUR', rate: Number(exchangeRates.eur?.rate) },
    //     ].filter((item) => !Number.isNaN(item.rate))
    //     : []

    const currencies = exchangeRates
        ? [
            {code: 'USD', rate: Number(exchangeRates.usd?.rate)},
            {code: 'RUB', rate: Number(exchangeRates.rub?.rate)},
            {code: 'EUR', rate: Number(exchangeRates.eur?.rate)},
        ]
        : []

    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
        if (!currencies.length) return

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % currencies.length)
        }, 5000)

        return () => clearInterval(interval)
    }, [currencies.length])

    useEffect(() => {
        if (currentIndex >= currencies.length) {
            setCurrentIndex(0)
        }
    }, [currencies.length])


    return (
        <div className={style.header}>
            <div className={cn('container-header', style['container-header'])}>
                <div className={cn('header-inner', style['header-inner'])}>
                    <NavLink
                        to="/tours"
                        onClick={() => {
                            dispatch(setTourFormalisationOpen(false));
                            dispatch(setSuccessPage(false));
                            dispatch(setTourChoiseOpen(true));
                            dispatch(setPassengersQuantity(''))
                            dispatch(setStepsState())
                            dispatch(setIsPreorder(0))
                        }}>
                        <div className={style.logo}>
                            <img
                                src={logo}
                                alt="logo"
                            />
                        </div>
                    </NavLink>
                    <div className={style.tabs}>
                        <NavLink
                            className={({isActive}) => {
                                return isActive ? "btn active" : "btn";
                            }}
                            to="/tours"
                            onClick={() => {
                                dispatch(setPassengersQuantity(''));
                                dispatch(setStepsState())
                                dispatch(setTourFormalisationOpen(false));
                                dispatch(setSuccessPage(false));
                                dispatch(setTourChoiseOpen(true));
                                dispatch(setIsPreorder(0))
                            }}
                        >
                            <TourSvg/>
                            <span>Таблица рейсов</span>
                        </NavLink>
                        <NavLink
                            className={({isActive}) => {
                                return isActive ? "btn active" : "btn";
                            }}
                            to="/history"
                            onClick={() => {
                                dispatch(setPassengersQuantity(''));
                                dispatch(setStepsState())
                                dispatch(triggerResetHistoryFilter());
                            }}
                        >
                            <HistorySvg/>
                            <span>История</span>
                        </NavLink>
                        {user.roleId === 2 && <NavLink
                            className={({isActive}) => {
                                return isActive ? "btn active" : "btn";
                            }}
                            to="/profile"
                            onClick={() => {
                                dispatch(setPassengersQuantity(''));
                                dispatch(setStepsState())
                            }}
                        >
                            <ProfileSvg/>
                            <span>Профиль</span>
                        </NavLink>}

                    </div>
                    {currencies.length > 0 && (
                        <div className={style.currency}>
                            <div className={style.currency__title}>Курсы валют</div>
                            <div className={style.currency__list}>
                                {currencies.map(item => (
                                    <div key={item.code} className={style.currency__item}>
                                        <span>{item.code}:</span>
                                        <span>{item.rate.toFixed(2)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className={style.name}>
                        <span>{user.roleTitle}</span>
                        <span>{user.fio}</span>
                    </div>
                    <Button svgComponent={NotificationSvg} className={style.notification} onClickFunc={() => {
                        if (!notification) {
                            dispatch(setNotification(true))
                            disableScroll()
                            dispatch(loadNotificationFunc({'order_by_date': 'desc'}))
                        }
                    }}>
                        <span>{notificationCount || notificationCount === 0 ? notificationCount : user.notificationsNewCount}</span>
                    </Button>
                    <Button onClickFunc={() => {
                        dispatch(logout())
                    }} svgComponent={ExitSvg} className={style.exit}>
                        <span>Выйти из аккаунта</span>
                    </Button>
                </div>
            </div>
        </div>
    )
}
